class StudioTheme {
  constructor() {
    this.body = document.body;
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.overlay = document.querySelector('[data-cart-overlay]');
    this.bindMenu();
    this.bindCart();
    this.bindProductForms();
  }

  bindMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const open = this.body.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    document.querySelectorAll('[data-site-nav] a').forEach((link) => link.addEventListener('click', () => {
      this.body.classList.remove('menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    }));
  }

  bindCart() {
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', () => this.openCart()));
    document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', () => this.closeCart()));
    this.overlay?.addEventListener('click', () => this.closeCart());
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.closeCart(); });
  }

  bindProductForms() {
    document.querySelectorAll('[data-product-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const original = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) throw new Error('Unable to add this work.');
          await this.openCart();
        } catch (error) {
          button.textContent = error.message;
          setTimeout(() => { button.textContent = original; button.disabled = false; }, 2200);
          return;
        }
        button.textContent = original;
        button.disabled = false;
      });
    });
  }

  async openCart() {
    await this.renderCart();
    this.body.classList.add('drawer-open');
    this.drawer?.setAttribute('aria-hidden', 'false');
    if (this.overlay) this.overlay.hidden = false;
  }

  closeCart() {
    this.body.classList.remove('drawer-open');
    this.drawer?.setAttribute('aria-hidden', 'true');
    if (this.overlay) this.overlay.hidden = true;
  }

  async renderCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const body = document.querySelector('[data-cart-body]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="empty-state">Your cart is empty.</p>';
      return;
    }
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency }).format(cents / 100);
    body.innerHTML = cart.items.map((item) => `
      <article class="drawer-line">
        <a href="${item.url}"><img src="${item.image}" alt="${this.escape(item.product_title)}"></a>
        <div><h3><a href="${item.url}">${this.escape(item.product_title)}</a></h3><p>${item.quantity} × ${money(item.final_price)}</p></div>
      </article>`).join('') + `
      <div class="drawer-total"><span>Total</span><strong>${money(cart.total_price)}</strong></div>
      <a class="drawer-checkout" href="/checkout">Checkout</a>`;
  }

  escape(value) {
    const node = document.createElement('div');
    node.textContent = value;
    return node.innerHTML;
  }
}

document.addEventListener('DOMContentLoaded', () => new StudioTheme());
